import ApiService from '~~commonAPIs/ApiService';

const PluginOrder = {
  createPluginOrder: ({ data }) => {
    return ApiService.post(`/api/plugin_orders`, { data });
  },

  updatePluginOrderReceipt: ({ pluginOrderUniqid, data }) => {
    return ApiService.put(`/api/plugin_orders/${pluginOrderUniqid}/receipt`, { data });
  },
};

export default PluginOrder;
